export class SubscriptionResponse
{
    public readonly subscriptionId:number;
    public readonly subscriptionStatus:any;
    public readonly startDate:number;
    public readonly cancelDate:number;
    public readonly productType:any;
    public readonly productGrant:string;
    public readonly productName:string;
    public readonly productDescription:string;
    public readonly productVariantId:number;
    public readonly price:number;
    public readonly pricePeriod:any;

    constructor(json:any)
    {
        this.subscriptionId = json['subscriptionId'];
        this.subscriptionStatus = json['subscriptionStatus'];
        this.startDate = json['startDate'];
        this.cancelDate = json['cancelDate'];
        this.productType = json['productType'];
        this.productGrant = json['productGrant'];
        this.productName = json['productName'];
        this.productDescription = json['productDescription'];
        this.productVariantId = json['productVariantId'];
        this.price = json['price'];
        this.pricePeriod = json['pricePeriod'];
    }
}
